var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F5F5",
    height: 1520,
    opacity: 0,
    width: 727.938,
    x: -539.984,
    y: -731
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#F54F33",
    r: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    id: "SVGID_31_",
    r: 64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_31_"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#DD2C24",
    points: "20.161,96.119 52.036,128 128,128 128,52.536 108.115,32.622    "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.944,96.947H23.056c-2.209,0-4-1.791-4-4V35.053c0-2.209,1.791-4,4-4h81.888c2.209,0,4,1.791,4,4    v57.894C108.944,95.156,107.153,96.947,104.944,96.947z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.944,42.054v-7.001c0-2.209-1.791-4-4-4H23.056c-2.209,0-4,1.791-4,4v7.001H108.944z",
    fill: "#E1E3E9"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 36.553,
    fill: "#F24B45",
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 36.553,
    fill: "#FFB202",
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.001,
    cy: 36.553,
    fill: "#4CBB41",
    r: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.944,96.947H23.056c-2.209,0-4-1.791-4-4V35.053c0-2.209,1.791-4,4-4h81.888c2.209,0,4,1.791,4,4      v57.894C108.944,95.156,107.153,96.947,104.944,96.947z",
    id: "SVGID_33_"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_33_"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_4_)",
    fill: "#E1E3E9",
    opacity: 0.8,
    points: "30.866,70.855 57.438,97.5 110,97.5 110,79.563      97.134,66.663 84.469,63.719 71.795,51.056 64.376,67.188 53.475,56.3 31.937,68.83    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.866,66.804L53.475,56.3v4.993l-17.099,7.49v0.094l17.099,7.489v4.993L30.866,70.855V66.804z",
    fill: "#53899F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.958,85.206l10.08-34.15h4.758l-10.081,34.15H56.958z",
    fill: "#53899F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.134,70.997L74.525,81.359v-4.993L92,68.877v-0.094l-17.476-7.49V56.3l22.609,10.363V70.997z",
    fill: "#53899F"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.a8d5a8b4255aafb12e8e903ef02f67ca.svg";
export { ForwardRef as ReactComponent };